// containers/Main/Main.js
import React from 'react';

export const Main = ({ children }) => {
  return (
    <div>
      {children}
    </div>
  );
};

export default Main;